import { useCallback, useEffect } from 'react';
import { useRouteMatch } from 'react-router';

import { AiAssistantEvent } from '@dreryk/egabinet-ai-assistant-frontend-api';

import { useCqrsEvent } from '@dreryk/command-query-react-common';

import { visitPaths } from '~libs.desktop.shared.paths';

import { useAiAssistantPhoneConnectionGlobalState } from '../../shared/useAiAssistantPhoneConnectionGlobalState';

const AI_ASSISTANT_WEB_EVENT_CONNECTED = 'connected';

export const AiAssistantPhoneConnectedEventListener = (): null => {
   const visitRouteMatch = useRouteMatch<{ visitId: string }>(visitPaths.VISIT_PATH);
   const visitId = Number(visitRouteMatch?.params.visitId);
   const { connect, reset } = useAiAssistantPhoneConnectionGlobalState();

   const handleAiAssistantEvent = useCallback(
      (event: AiAssistantEvent) => {
         if (event.visitId === visitId && event.event === AI_ASSISTANT_WEB_EVENT_CONNECTED) {
            connect();
         }
      },
      [visitId, connect]
   );

   useCqrsEvent<AiAssistantEvent>('egabinet-ai-assistant-frontend-api:AiAssistantEvent', handleAiAssistantEvent);

   useEffect(() => reset, [reset]);

   return null;
};
